import { Txt } from "@stenajs-webui/core";
import { Card, CardBody } from "@stenajs-webui/elements";
import { cssColor } from "@stenajs-webui/theme";
import { useMemo } from "react";
import { groupReservedBookingsByRoute } from "../../lib/reservedBookingUtils";
import { RebateBookingsForRoute } from "./RebateBookingsForRoute";
import { RebateBookingsOverview } from "../../types/types";

interface Props {
  rebate: RebateBookingsOverview;
}

export const RebateBookingsByRoute = ({ rebate }: Props) => {
  const routes = useMemo(() => groupReservedBookingsByRoute(rebate), [rebate]);

  if (routes.length === 0) {
    return (
      <Card>
        <CardBody>
          <Txt color={cssColor("--lhds-color-ui-500")}>
            No reserved bookings on this rebate goal.
          </Txt>
        </CardBody>
      </Card>
    );
  }

  return (
    <>
      {routes.map((route) => (
        <RebateBookingsForRoute
          key={route.routeCode}
          route={route}
          currencyCode={rebate.rebateAgreement?.currencyCode}
        />
      ))}
    </>
  );
};
